export const ADDITIONAL_HEALTH_SAVE = 'additionalHealth/save';
export const ADDITIONAL_HEALTH_SAVE_FAILED = 'additionalHealth/save/failed';
export const ADDITIONAL_HEALTH_SAVE_SUCCESS = 'additionalHealth/save/sucess';
export const ADDITIONAL_HEALTH_SAVE_PAPERWORK = 'additionalHealth/save_paperwork';
export const ADDITIONAL_HEALTH_SAVE_PAPERWORK_FAILED = 'additionalHealth/save_paperwork/failed';
export const ADDITIONAL_HEALTH_SAVE_PAPERWORK_SUCCESS = 'additionalHealth/save_paperwork/sucess';
export const ADDITIONAL_HEALTH_START = 'additionalHealth/start';
export const ADDITIONAL_HEALTH_START_FAILED = 'additionalHealth/start/failed';
export const ADDITIONAL_HEALTH_START_SUCCESS = 'additionalHealth/start/success';

export const ActionType = {
    ADDITIONAL_HEALTH_SAVE,
    ADDITIONAL_HEALTH_SAVE_FAILED,
    ADDITIONAL_HEALTH_SAVE_SUCCESS,
    ADDITIONAL_HEALTH_SAVE_PAPERWORK,
    ADDITIONAL_HEALTH_SAVE_PAPERWORK_FAILED,
    ADDITIONAL_HEALTH_SAVE_PAPERWORK_SUCCESS,
    ADDITIONAL_HEALTH_START,
    ADDITIONAL_HEALTH_START_FAILED,
    ADDITIONAL_HEALTH_START_SUCCESS,
} as const;

export type ActionType = (typeof ActionType)[keyof typeof ActionType];
